import {
  BrowserRouter as Router,
  Switch,
  Route,
  NavLink,
} from "react-router-dom";
// import { Navbar, Nav, Container, Alert, Button } from "react-bootstrap";
import { AppLayout,Alert,Notifications, Header, Link, BreadcrumbGroup, TopNavigation, Container, Button, Grid} from "@cloudscape-design/components"
import Home from "./routes/Home";
import Search from "./routes/Search";
import Dashboard from "./routes/Dashboard/index";
import { useState } from "react";
import { payloadFromToken, logOut } from "./api/auth";

import nexonlogo from "./Nexon/nexonlogo-1.svg";
import "./Nexon/nexon.css";
import Nexon_Addson from "./Nexon/nexon_addson";

//if user open call detail, get the call recording file name eq. ....json (metadata file)
let callrecording_filename =window.location.href.substring(window.location.href.lastIndexOf('/') + 1)
let mediaURI = window.localStorage.getItem("selectedCall")!=null && window.localStorage.getItem("selectedCall")!='' && window.localStorage.getItem("selectedCall")!=undefined ? window.localStorage.getItem("selectedCall").split("?")[0]:'No call selected!!';
//check if User in Call Detail, then show Nexon-Addson button , but if in Home or Call List dont show Nexon-AddsOn button
let isCallDetailPage = window.location.href.indexOf(".json")>=0 ? true: false;

//check if callrecording_filename is empty means user is in Home or Call List, no need to pass call recording file name in querystring,
//but if user in Call Detail, then when they click on Nexon Adds-On, put call recording filename in the query string
let nexon_addons_href;
//case1 user not in Call Detail nor Nexon-AddsOn, instead in Home or Call List, then Nexon AddsOn will not show, so not need href
if(!isCallDetailPage)
{
  nexon_addons_href='';
}

/*Nexon Adds-on

2024 - 04 - 21
Added import 
  1. Nexon Logo from Nexon/nexonlogo-1.svg
  2. Nexon css from Nexon/nexon.css
  3. Nexon_AddsOn page from Nexon/nexon_addson

In the Routes add section Component Nexon Adds-on

In the Top Navigation:
  1. Update identity to use Nexon Logo
  2. Added NexonAdds_On section after Search
*/


const routes = [
  {
    path: "/search",
    name: "Search",
    Component: Search,
    Breadcrumb: () => {
      return <BreadcrumbGroup
        items={[
          { text: "Home", href: "../" },
          { text: "Search", href: "search" }
        ]}
        ariaLabel="Breadcrumbs"
      />
    }
  },
  {
    path: "/dashboard/parsedFiles/search",
    name: "Search",
    Component: Search,
    Breadcrumb: () => {
      return <BreadcrumbGroup
        items={[
          { text: "Home", href: "../" },
          { text: "Search", href: "search" }
        ]}
        ariaLabel="Breadcrumbs"
      />
    }
  },
  {
    path: "/dashboard/:key*",
    name: "Call Details",
    hide: true,
    Component: Dashboard,
    Breadcrumb: () => {
      return <BreadcrumbGroup
        items={[
          { text: "Home", href: "/" }, //used to be ../../
          { text: "Call List", href: "/" }, //used to be ../../
          { text: "Call Details", href: "#" },
        ]}
        ariaLabel="Breadcrumbs"
      />
    }
  },
  {
    path: "/Nexon/nexon_addson",
    name: "Nexon Adds on",
    hide: true,
    Component: Nexon_Addson,
    Breadcrumb: () => {
      return <BreadcrumbGroup
        items={[
          { text: "Home", href: "../../" },
          { text: "Call List", href: "../../" },
          { text: "Nexon Adds on", href: "#" },
        ]}
        ariaLabel="Breadcrumbs"
      />
    }
  },  
  {
    path: "/",
    name: "Call List",
    Component: Home,
    Breadcrumb: () => {
      return <BreadcrumbGroup
        items={[
          { text: "Home", href: "#" },
          { text: "Call List", href: "#" },
        ]}
        ariaLabel="Breadcrumbs"
      />
    }
  },
];


function Navigation({ userName, email }) {
  if(isCallDetailPage)
  {
    return (
      <TopNavigation
        identity={{
          href: "/",
          logo:{ src:nexonlogo, alt:"Nexon" },
          iconName: "settings"
        }}
        i18nStrings={{
          searchIconAriaLabel: "Search",
          searchDismissIconAriaLabel: "Close search",
          overflowMenuTriggerText: "More",
          overflowMenuTitleText: "All",
          overflowMenuBackIconAriaLabel: "Back",
          overflowMenuDismissIconAriaLabel: "Close menu"
        }}
        utilities={[
          {
            type: "button",
            text: "Search",
            iconName: "search",
            href: "search",
            externalIconAriaLabel: " (opens in a new tab)"
          },
          {
            type: "button",
            text: "Nexon Adds-on",
            hide: true,
            href: nexon_addons_href,
            externalIconAriaLabel: " (opens in a new tab)"
          },
          {
            type: "menu-dropdown",
            text: userName,
            description: email,
            iconName: "user-profile",
            onItemClick: (event) => {
              console.log(event);
              if (event.detail.id === "signout") logOut();
            },
            items: [
              { id: "signout", text: "Sign out" }
            ]
          }
        ]}
        className="navigationclass"
      />
    );
  }
  else
  {
    return (
      <TopNavigation
        identity={{
          href: "/",
          logo:{ src:nexonlogo, alt:"Nexon" },
          iconName: "settings"
        }}
        i18nStrings={{
          searchIconAriaLabel: "Search",
          searchDismissIconAriaLabel: "Close search",
          overflowMenuTriggerText: "More",
          overflowMenuTitleText: "All",
          overflowMenuBackIconAriaLabel: "Back",
          overflowMenuDismissIconAriaLabel: "Close menu"
        }}
        utilities={[
          /*{
            type: "button",
            text: "Search",
            iconName: "search",
            href: "search",
            externalIconAriaLabel: " (opens in a new tab)"
          },*/
          {
            type: "menu-dropdown",
            text: userName,
            description: email,
            iconName: "user-profile",
            onItemClick: (event) => {
              console.log(event);
              if (event.detail.id === "signout") logOut();
            },
            items: [
              { id: "signout", text: "Sign out" }
            ]
          }
        ]}
        className="navigationclass"
      />
    );
  }

}

function BottomNavigation() {
  return (
    <Grid
      className="bottomnavigationclass" gridDefinition={[{ colspan: 1}, { colspan: 9 }, { colspan: 1 }]} >
      <div></div>
      <div class="nexon_footer">Nexon Playback and Analytics</div>
      <div class="nexon_footer">v.0.1.0</div>
    </Grid>
  );
}


function App() {
  const [alert, setAlert] = useState();

  const onDismiss = () => {
    setAlert(null);
  };

  const userToken = localStorage.getItem("id_token");
  const parsedToken = payloadFromToken(userToken);
  const cognitoUserName = parsedToken["cognito:username"] || "Unknown";
  const cognitoEmail = parsedToken["email"] || "Unknown";

  return (
    <Router>
      <Switch>
        {routes.map(({ path, Component, Breadcrumb, name }) => (
          <Route key={path} path={path}>
            <Navigation userName={cognitoUserName} email={cognitoEmail} />
            <AppLayout
              stickyNotifications
              toolsHide
              navigationHide
              breadcrumbs={
                <Breadcrumb/>
              }
              notifications={alert && (
                <Alert
                  variant={alert.variant}
                  dismissible
                  header={alert.heading}
                  onDismiss={onDismiss}
                >
                  {alert.text}
                </Alert>
              )}
              content={
                <Component setAlert={setAlert} />
              }
            />
            <BottomNavigation  />
          </Route>
        ))}
      </Switch>
    </Router>
  );
}

export default App;
